import { Show, createSignal } from 'solid-js';
import { Logo } from '../components/Icons';
import { devSignIn, signInWithGoogle } from '../lib/app';
import { config, isConfigured } from '../lib/config';

export default function SignIn(props: { error?: string | null }) {
  const [busy, setBusy] = createSignal(false);
  const [error, setError] = createSignal<string | null>(props.error ?? null);
  const [email, setEmail] = createSignal('');
  const [password, setPassword] = createSignal('');
  const goDev = async (e: Event) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await devSignIn(email(), password());
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };
  const go = async () => {
    setBusy(true);
    setError(null);
    try {
      await signInWithGoogle();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
      setBusy(false);
    }
  };
  return (
    <div class="signin">
      <div class="ribbon idle" />
      <div class="signin-card">
        <div class="brand big">
          <Logo /> bsync
        </div>
        <h1>One bookmark library for Chrome and Firefox.</h1>
        <p class="lede">
          Folders, order and edits stay in step across every browser you sign in to. You can also see which extensions each browser is missing.
        </p>
        <Show
          when={isConfigured()}
          fallback={
            <div class="notice bad">
              This deployment isn’t configured yet. Set <code>VITE_SUPABASE_URL</code> and <code>VITE_SUPABASE_ANON_KEY</code> and rebuild. docs/SETUP.md walks through it.
            </div>
          }
        >
          <button class="btn google" onClick={go} disabled={busy()}>
            <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
              <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
              <path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
              <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
              <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
            </svg>
            {busy() ? 'Redirecting to Google…' : 'Continue with Google'}
          </button>
        </Show>
        <Show when={isConfigured() && config.devEmailLogin}>
          <form class="dev-login" onSubmit={goDev}>
            <p class="fine">Development sign-in for the local stack. Creates the account on first use.</p>
            <input class="input" type="email" placeholder="you@example.com" autocomplete="username" value={email()} onInput={(e) => setEmail(e.currentTarget.value)} aria-label="Email" />
            <input class="input" type="password" placeholder="Password (6+ characters)" autocomplete="current-password" value={password()} onInput={(e) => setPassword(e.currentTarget.value)} aria-label="Password" />
            <button class="btn" type="submit" disabled={busy()}>
              Sign in with email
            </button>
          </form>
        </Show>
        <Show when={error()}>
          <p class="form-error" role="alert">
            {error()}
          </p>
        </Show>
        <p class="fine">Your data lives in your own Supabase project. Only you can read it.</p>
      </div>
    </div>
  );
}
